import { Alert, Button, DataTable, Skeleton } from "@nabble/ui";
import type { DataRequest } from "../../../../api/dataRequests";
import { DATA_REQUEST_COLUMNS } from "./dataRequestColumns";

interface DataRequestsListProps {
  /** `null` while loading. */
  requests: DataRequest[] | null;
  loadError: string | null;
  onRetry: () => void;
}

/** The person's requests, or why they couldn't be loaded, or a placeholder while they load. */
export function DataRequestsList({ requests, loadError, onRetry }: DataRequestsListProps): React.JSX.Element {
  if (loadError) {
    return (
      <Alert tone="danger" title="We couldn't load your requests">
        {loadError} <Button label="Try again" variant="ghost" size="sm" icon="refresh" onClick={onRetry} />
      </Alert>
    );
  }
  if (requests === null) return <Skeleton height={40} radius={10} />;
  if (requests.length === 0) return <p className="nb-help">You haven&apos;t made any requests.</p>;
  return (
    <DataTable<DataRequest>
      minimal
      rowKey="id"
      rows={requests}
      columns={DATA_REQUEST_COLUMNS}
      defaultSort={{ key: "createdAt", dir: "desc" }}
      ariaLabel="Your requests"
    />
  );
}
